import FingerprintJS from '@fingerprintjs/fingerprintjs-pro';

/**
 * Collects the device visitorId via FingerprintJS. Best-effort only — never blocks
 * registration. The blacklist check itself runs server-side in lib/auth.ts hooks.before.
 */
export const collectVisitorId = async (): Promise<string | null> => {
  try {
    const fpjsPublicApiKey = process.env.NEXT_PUBLIC_FINGERPRINTJS_API_KEY as string;

    if (!fpjsPublicApiKey) {
      return null;
    }

    const fp = await FingerprintJS.load({
      apiKey: fpjsPublicApiKey,
      endpoint: [
        'https://fp.hondubet.com',
        'https://api.fpjs.io',
      ],
      scriptUrlPattern: [
        'https://fp.hondubet.com/web/v<version>/<apiKey>/loader_v<loaderVersion>.js',
        'https://api.fpjs.io/v<version>/<apiKey>/loader_v<loaderVersion>.js',
      ],
    });

    const { visitorId } = await fp.get();
    return visitorId ?? null;
  } catch (error) {
    console.warn('Failed to collect device fingerprint:', error);
    return null;
  }
};
